import React, { Component } from 'react';
import './App.css';
import Measure from 'react-measure';
import PhotoGallery from './PhotoGallery';
import FilterBar from './FilterBar';
import sizeOf from 'image-size';
import bathroom from './Photos/bathroom.jpg'
/*
import Montana135Bathroom from './Photos/Montana135Bathroom.jpg'
import Montana135Bedroom from './Photos/Montana135Bedroom.jpg'
import Montana135Bedroom2 from './Photos/Montana135Bedroom2.jpg'
import Montana135Bedroom3 from './Photos/Montana135Bedroom3.jpg'
import Montana135Desk from './Photos/Montana135Desk.jpg'
import Montana135Entry from './Photos/Montana135Entry.jpg'
import Montana135ExteriorGreenery from './Photos/Montana135ExteriorGreenery.jpg'
import Montana135ExteriorWhiteHall from './Photos/Montana135ExteriorWhiteHall.jpg'
import Montana135FountainView from './Photos/Montana135FountainView.jpg'
import Montana135Front from './Photos/Montana135Front.jpg'
import Montana135Kitchen from './Photos/Montana135Kitchen.jpg'
import Montana135LivingRoom from './Photos/Montana135LivingRoom.jpg'
import Montana135LivingRoom2 from './Photos/Montana135LivingRoom2.jpg'
import Montana135Path from './Photos/Montana135Path.jpg'
import Montana135PropertyCourtyard from './Photos/Montana135PropertyCourtyard.jpg'
import Montana135UnitBedroom from './Photos/Montana135UnitBedroom.jpg'
import Montana135UnitHallwayView from './Photos/Montana135UnitHallwayView.jpg'
import Montana135UnitLivingRoom from './Photos/Montana135UnitLivingRoom.jpg'
import Montana435DiningRoom from './Photos/Montana435DiningRoom.jpg'
import Montana435DiningRoomExpandedView from './Photos/Montana435DiningRoomExpandedView.jpg'
import Montana435Entry from './Photos/Montana435Entry.jpg'
import Montana435Front from './Photos/Montana435Front.jpg'
import Montana435KitchenBlue from './Photos/Montana435KitchenBlue.jpg'
import Montana435KitchenGrey from './Photos/Montana435KitchenGrey.jpg'
import Montana435LivingRoom2 from './Photos/Montana435LivingRoom2.jpg'
import Montana435OfficeHallway from './Photos/Montana435OfficeHallway.jpg'
import Studio135Montana from './Photos/Studio135Montana.jpg'
import ToiletAndSink from './Photos/ToiletAndSink.jpg'
import ViewFrom135 from './Photos/ViewFrom135.jpg'
*/
import _135Courtyard from './GalleryPhotos/135_Courtyard.jpg';
import _135ExteriorBackstairs from './GalleryPhotos/135_ExteriorBackstairs.jpg';
import _135ExteriorEntry from './GalleryPhotos/135_ExteriorEntry.jpg';
import _135ExteriorWhiteHall from './GalleryPhotos/135_ExteriorWhiteHall.jpg';
import _135ExteriorEntry2 from './GalleryPhotos/135_ExteriorEntry2.jpg';
import _135ExteriorGreen from './GalleryPhotos/135_ExteriorGreen.jpg';
import _135Front from './GalleryPhotos/135_Front.jpg';
import _135Ivywall from './GalleryPhotos/135_Ivywall.jpg';

import _135Ivywall2 from './GalleryPhotos/135_Ivywall2.jpg';
import _135U1Bathroom from './GalleryPhotos/135U1_Bathroom.jpg';
import _135U1Bedroom1 from './GalleryPhotos/135U1_Bedroom1.jpg';
import _135U1Bedroom2 from './GalleryPhotos/135U1_Bedroom2.jpg';
import _135U1Kitchen from './GalleryPhotos/135U1_Kitchen.jpg';
import _135U1LivingRoom from './GalleryPhotos/135U1_LivingRoom.jpg';
import _135U3Bathroom from './GalleryPhotos/135U3_Bathroom.jpg';
import _135U3Bedroom from './GalleryPhotos/135U3_Bedroom.jpg';
import _135U3Kitchen from './GalleryPhotos/135U3_Kitchen.jpg';
import _135U3StudioLayout from './GalleryPhotos/135U3_StudioLayout.jpg';

import _135U11LivingRoom from './GalleryPhotos/135U11_LivingRoom.jpg';
import _135U11Kitchen from './GalleryPhotos/135U11_Kitchen.jpg';
// import _135U11Bathroom from './GalleryPhotos/135U11_Bathroom.jpg';
import _135U11Bedroom from './GalleryPhotos/135U11_Bedroom.jpg';

import _135U12Bathroom from './GalleryPhotos/135U12_Bathroom.jpg';
import _135U12Bathroom2 from './GalleryPhotos/135U12_Bathroom2.jpg';
import _135U12Bedroom from './GalleryPhotos/135U12_Bedroom.jpg';
import _135U12Bedroom2 from './GalleryPhotos/135U12_Bedroom2.jpg';
import _135U12LivingRoom from './GalleryPhotos/135U12_LivingRoom.jpg';
import _435Bathroom from './GalleryPhotos/435_Bathroom.jpg';
import _435Bathroom2 from './GalleryPhotos/435_Bathroom2.jpg';
import _435Bedroom1 from './GalleryPhotos/435_Bedroom1.jpg';
import _435Bedroom2 from './GalleryPhotos/435_Bedroom2.jpg';
import _435Bedroom3 from './GalleryPhotos/435_Bedroom3.jpg';
import _435Bedroom4 from './GalleryPhotos/435_Bedroom4.jpg';
import _435Closet from './GalleryPhotos/435_Closet.jpg';
import _435Closet2 from './GalleryPhotos/435_Closet2.jpg';
import _435DiningRoomClose from './GalleryPhotos/435_DiningRoomClose.jpg';
import _435Front from './GalleryPhotos/435_Front.jpg';
import _435FrontWithGate from './GalleryPhotos/435_FrontWithGate.jpg';
import _435Kitchen from './GalleryPhotos/435_Kitchen.jpg';
import _435Kitchen2 from './GalleryPhotos/435_Kitchen2.jpg';
import _435LivingRoom from './GalleryPhotos/435_LivingRoom.jpg';
import _435Office from './GalleryPhotos/435_Office.jpg';
import _435Shower from './GalleryPhotos/435_Shower.jpg';
import _435Shower2 from './GalleryPhotos/435_Shower2.jpg';
import _435ViewFromDoor from './GalleryPhotos/435_ViewFromDoor.jpg';
import _8900Bathroom from './GalleryPhotos/8900_Bathroom.jpg';
import _8900Bedroom from './GalleryPhotos/8900_Bedroom.jpg';
import _8900Bedroom2 from './GalleryPhotos/8900_Bedroom2.jpg';
import _8900Bedroom3 from './GalleryPhotos/8900_Bedroom3.jpg';
import _8900Entry from './GalleryPhotos/8900_Entry.jpg';
import _8900FamilyRoom from './GalleryPhotos/8900_FamilyRoom.jpg';
import _8900FirstFloor from './GalleryPhotos/8900_FirstFloor.jpg';
import _8900Front from './GalleryPhotos/8900_Front.jpg';
import _8900Front2 from './GalleryPhotos/8900_Front2.jpg';
import _8900Front3 from './GalleryPhotos/8900_Front3.jpg';
import _8900Kitchen from './GalleryPhotos/8900_Kitchen.jpg';
import _8900MasterBath2 from './GalleryPhotos/8900_MasterBath2.jpg';
import _8900MasterBathroom from './GalleryPhotos/8900_MasterBathroom.jpg';
import _8900Pool2 from './GalleryPhotos/8900_Pool2.jpg';
import _8900Sink from './GalleryPhotos/8900_Sink.jpg';
import _8900UpperBathroom from './GalleryPhotos/8900_UpperBathroom.jpg';
import _8902LivingRoom from './GalleryPhotos/8902_LivingRoom.jpg';
import _8902Kitchen from './GalleryPhotos/8902_Kitchen.jpg';

import { CloudinaryContext, Transformation, Image } from 'cloudinary-react';
import axios from 'axios';
import cloudinary from 'cloudinary-core';
import SEOHiddenText from './SEOHiddenText';


const cloudinaryCore = new cloudinary.Cloudinary({cloud_name: 'dw1wpzvqa'});

class Gallery extends Component {
  constructor(){
    super()
    this.state = {
      //photoSource: allPhotos,
      photoSource: allPhotos,
      activeFilters: {city: false, interiorExterior: false, property: false},
      options : gallery_options,
      cities : city_list,
      interiorExterior : interior_exterior,
      ph1Filter: "Property",
      ph2Filter: "Interior | Exterior",
      ph3Filter: "City",
      width: -1,
      images: []
    }
    this.update2 = this.update2.bind(this);
    this.changeCityBasedOnProperty = this.changeCityBasedOnProperty.bind(this);
    this.clearValues = this.clearValues.bind(this);
  }

  componentWillMount(){
    //scroll to top of page once component will load
    document.body.scrollTop = document.documentElement.scrollTop = 0;

    //change classes of navbar so it is the appropriate height, color & more
    this.props.changeClass()
  }

  componentDidMount() {
    // Request for images tagged xmas
    // console.log('request to get photos 7/19/18!', cloudinaryCore);

    axios.get('https://res.cloudinary.com/dw1wpzvqa/image/list/All.json').then(res => {
      console.log('res: ');
    })

    axios.get('https://res.cloudinary.com/dw1wpzvqa/image/list/All.json')
        .then(res => {
            console.log('res');
            // this.setState({photoSource: res.data.resources})

            //this.setState({gallery: res.data.resources});
        });
  }

  changeCityBasedOnProperty(x){
    var cityChange = false
    if(x.property === 'All'){
      cityChange = {disabled: false, city: 'All'}
    }
    if(x.property === Montana135 || x.property === Montana435){
      cityChange = {disabled: true, city: Santa_Monica}
    }
    if(x.property === Rangely8900){
      cityChange = {disabled: true, city: West_Hollywood}
    }
    return cityChange
  }

  clearValues(){
    this.setState({
      activeFilters: {city: false, property: false, interiorExterior: false},
      cityDisabled: false,
      photoSource: allPhotos,
      clearButtonDisabled: true
    })
  }

  update2(x){
    var newFilterKey = '', newFilterValue = '', newActiveFilters = this.state.activeFilters;
    //get new filter
    if (x.property) {
      newFilterKey = "property";
      newFilterValue = x.property;
    } else if (x.interiorExterior) {
      newFilterKey = "interiorExterior";
      newFilterValue = x.interiorExterior;
    } else if (x.city) {
      newFilterKey = "city";
      newFilterValue = x.city;
    }
    //change old filter to new filter
    newActiveFilters[newFilterKey] = newFilterValue
    //get city disabled value (true/false) and city filter value ('All'/'SM'/'WH') -- city filter value may not be correct
    var cityBasedOnProperty = this.changeCityBasedOnProperty(newActiveFilters)
    //if new filter is property, then city filter value is correct. Change city filter value
    if(newFilterKey === 'property') newActiveFilters.city = cityBasedOnProperty.city;
    //create new photo source called 'newUnitsToView'
    var newUnitsToView = allPhotos.filter((y) => {
      var openSeasame = false;
      //for all keys in apartment object
      for(var key in y){
        //if key is also a filter object continue...
        if(newActiveFilters.hasOwnProperty(key) && newActiveFilters[key]){
          //if apt obj value equals the filter or if the filter is All, continue...
          if(y[key] === newActiveFilters[key] || newActiveFilters[key] === 'All'){
            //set to true -- this can get overwritten later if another value doesn't match a different filter
            openSeasame = true;
          } else {
            //apt obj doesn't pass filter
            return false;
          }
        }
      }
      return openSeasame;
    })
    this.setState({
      activeFilters: newActiveFilters,
      photoSource: newUnitsToView,
      cityDisabled: cityBasedOnProperty.disabled,
      clearButtonDisabled: false
    })
  }

  render(){
    var t = this, s = this.state
    const width = this.state.width;
    return (
      <Measure bounds onResize={(contentRect) => this.setState({ width: contentRect.bounds.width })}>
        {
        ({measureRef}) => {
          if (width < 1 ) return (<div ref={measureRef}></div>);
          let columns = 1;
          if (width >= 480) columns = 2;
          if (width >= 1024) columns = 3;
          if (width >= 1824) columns = 4;
          return (
            <div className="galleryContainer" ref={measureRef}>
              <FilterBar clearButtonDisabled={s.clearButtonDisabled} clearValues={t.clearValues} cityDisabled={s.cityDisabled} filter1={s.options} ph1Filter={s.ph1Filter} filter2={s.interiorExterior} ph2Filter={s.ph2Filter} filter3={s.cities} interiorExterior={'' || s.activeFilters.interiorExterior} city={'' || s.activeFilters.city } ph3Filter={s.ph3Filter}
                property={'' || s.activeFilters.property} update2={this.update2} update={this.update} label="States" />
              <PhotoGallery photos={s.photoSource} columns={columns} />
            </div>
          )
        }
      }
      </Measure>
    )
  }
}

export default Gallery;


// CONSTANTS
const Montana135 = '135 Montana Ave';
const Montana435 = '435 Montana Ave';
const Rangely8900 = '8900 Rangely Ave';
const Santa_Monica = 'Santa Monica';
const West_Hollywood = 'West Hollywood';
const styling = {
  diagonalBackgroundHeader: {
    backgroundAttachment: 'fixed',
    transform: 'skewY(6.5deg)',
    margin: '-12% 0px',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundSize: 'cover'
  }
}
const gallery_options = [
  { value: 'All', label: 'All', className: 'filterInput' },
  { value: Montana135, label: Montana135, className: 'filterInput'},
  { value: Montana435, label: Montana435, className: 'filterInput' },
  { value: Rangely8900, label: Rangely8900, className: 'filterInput' }
]
const city_list = [
  { value: 'All', label: 'All', className: 'filterInput' },
  { value: 'Santa Monica', label: 'Santa Monica', className: 'filterInput' },
  { value: 'West Hollywood', label: 'West Hollywood', className: 'filterInput' }
]
const interior_exterior = [
  { value: 'All', label: 'All', className: 'filterInput' },
  { value: 'Interior', label: 'Interior', className: 'filterInput' },
  { value: 'Exterior', label: 'Exterior', className: 'filterInput' },
]


const allPhotos =[
    { src: _135Front, width: 1.5, height: 1, interiorExterior: 'Exterior', property: Montana135, city: Santa_Monica},
    { src: _135ExteriorWhiteHall, width: 1.5, height: 1, interiorExterior: 'Exterior', property: Montana135, city: Santa_Monica},
    { src: _8900Sink, width: 1.5, height: 1, interiorExterior: 'Interior', property: Rangely8900, city: West_Hollywood},
    { src: _8900FirstFloor, width: 1.5, height: 1, interiorExterior: 'Interior', property: Rangely8900, city: West_Hollywood},
    { src: _135U3Kitchen, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana135, city: Santa_Monica},
    { src: _135ExteriorGreen, width: 1.5, height: 1, interiorExterior: 'Exterior', property: Montana135, city: Santa_Monica},
    { src: _435FrontWithGate, width: 1.5, height: 1, interiorExterior: 'Exterior', property: Montana435, city: Santa_Monica},
    { src: _435DiningRoomClose, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana435, city: Santa_Monica},
    { src: _435Kitchen, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana435, city: Santa_Monica},
    { src: _435Shower, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana435, city: Santa_Monica},
    { src: _8900Front2, width: 1.5, height: 1, interiorExterior: 'Exterior', property: Rangely8900, city: West_Hollywood},
    { src: _8900Kitchen, width: 1.5, height: 1, interiorExterior: 'Interior', property: Rangely8900, city: West_Hollywood},
    { src: _8900MasterBath2, width: 1.5, height: 1, interiorExterior: 'Interior', property: Rangely8900, city: West_Hollywood},
    { src: _435Bedroom1, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana435, city: Santa_Monica},
    { src: _435Bathroom, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana435, city: Santa_Monica},
    { src: _435Bedroom2, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana435, city: Santa_Monica},
    { src: _435Closet2, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana435, city: Santa_Monica},
    { src: _435Bathroom2, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana435, city: Santa_Monica},
    { src: _435Bedroom3, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana435, city: Santa_Monica},
    { src: _435Bedroom4, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana435, city: Santa_Monica},
    { src: _435Closet, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana435, city: Santa_Monica},
    { src: _435Kitchen2, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana435, city: Santa_Monica},
    { src: _435LivingRoom, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana435, city: Santa_Monica},
    { src: _435Office, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana435, city: Santa_Monica},
    { src: _435Shower2, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana435, city: Santa_Monica},
    { src: _435ViewFromDoor, width: 1.5, height: 1, interiorExterior: 'Exterior', property: Montana435, city: Santa_Monica},
    { src: _8900Bedroom, width: 1.5, height: 1, interiorExterior: 'Interior', property: Rangely8900, city: West_Hollywood},
    { src: _8900Bathroom, width: 1.5, height: 1, interiorExterior: 'Interior', property: Rangely8900, city: West_Hollywood},
    { src: _8900Bedroom2, width: 1.5, height: 1, interiorExterior: 'Interior', property: Rangely8900, city: West_Hollywood},
    { src: _8900Front, width: 1.5, height: 1, interiorExterior: 'Exterior', property: Rangely8900, city: West_Hollywood},
    { src: _8900Bedroom3, width: 1.5, height: 1, interiorExterior: 'Interior', property: Rangely8900, city: West_Hollywood},
    { src: _8900Entry, width: 1.5, height: 1, interiorExterior: 'Interior', property: Rangely8900, city: West_Hollywood},
    { src: _8900MasterBathroom, width: 1.5, height: 1, interiorExterior: 'Interior', property: Rangely8900, city: West_Hollywood},
    { src: _8902LivingRoom, width: 1.5, height: 1, interiorExterior: 'Interior', property: Rangely8900, city: West_Hollywood},
    { src: _8902Kitchen, width: 1.5, height: 1, interiorExterior: 'Interior', property: Rangely8900, city: West_Hollywood},
    { src: _8900Pool2, width: 1.5, height: 1, interiorExterior: 'Exterior', property: Rangely8900, city: West_Hollywood},
    { src: _8900FamilyRoom, width: 1.5, height: 1, interiorExterior: 'Interior', property: Rangely8900, city: West_Hollywood},
    { src: _8900UpperBathroom, width: 1.5, height: 1, interiorExterior: 'Interior', property: Rangely8900, city: West_Hollywood},
    { src: _135ExteriorBackstairs, width: 1.5, height: 1, interiorExterior: 'Exterior', property: Montana135, city: Santa_Monica},
    { src: _135ExteriorEntry, width: 1.5, height: 1, interiorExterior: 'Exterior', property: Montana135, city: Santa_Monica},
    { src: _135ExteriorEntry2, width: 1.5, height: 1, interiorExterior: 'Exterior', property: Montana135, city: Santa_Monica},
    { src: _135Ivywall, width: 1.5, height: 1, interiorExterior: 'Exterior', property: Montana135, city: Santa_Monica},
    { src: _135Ivywall2, width: 1.5, height: 1, interiorExterior: 'Exterior', property: Montana135, city: Santa_Monica},
    { src: _135U1Bathroom, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana135, city: Santa_Monica},
    { src: _135U1Bedroom1, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana135, city: Santa_Monica},
    { src: _135U1Bedroom2, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana135, city: Santa_Monica},
    { src: _135U1Kitchen, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana135, city: Santa_Monica},
    { src: _135U1LivingRoom, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana135, city: Santa_Monica},
    { src: _135U3Bathroom, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana135, city: Santa_Monica},
    { src: _135U3Bedroom, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana135, city: Santa_Monica},
    { src: _135U3StudioLayout, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana135, city: Santa_Monica},
    { src: _135U11LivingRoom, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana135, city: Santa_Monica},
    { src: _135U11Kitchen, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana135, city: Santa_Monica},
    { src: _135U11Bedroom, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana135, city: Santa_Monica},
    { src: _135U12Bathroom, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana135, city: Santa_Monica},
    { src: _135U12Bathroom2, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana135, city: Santa_Monica},
    { src: _435Front, width: 1.5, height: 1, interiorExterior: 'Exterior', property: Montana435, city: Santa_Monica},
    { src: _135U12Bedroom, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana135, city: Santa_Monica},
    { src: _135Courtyard, width: 1.5, height: 1, interiorExterior: 'Exterior', property: Montana135, city: Santa_Monica},
    { src: _135U12Bedroom2, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana135, city: Santa_Monica},
    { src: _135U12LivingRoom, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana135, city: Santa_Monica}
]




/*


const allPhotos = [
  { src: Montana435DiningRoom, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana435, city: Santa_Monica
  },
  { src: Montana135ExteriorGreenery, width: 1.5, height: 1, interiorExterior: 'Exterior', property: Montana135, city: Santa_Monica
  },
  { src: Montana435KitchenBlue, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana435, city: Santa_Monica
  },
  { src: Montana135Bedroom, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana135, city: Santa_Monica
  },
  { src: Montana435Front, width: 1.5, height: 1, interiorExterior: 'Exterior', property: Montana435, city: Santa_Monica
  },
  { src: Montana435OfficeHallway, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana435, city: Santa_Monica
  },
  { src: Montana135ExteriorWhiteHall, width: 1.5, height: 1, interiorExterior: 'Exterior', property: Montana135, city: Santa_Monica
  },
  { src: Montana135Bedroom2, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana135, city: Santa_Monica
  },
  { src: Montana135Front, width: 1.5, height: 1, interiorExterior: 'Exterior', property: Montana135, city: Santa_Monica
  },
  { src: Montana135Bathroom, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana135, city: Santa_Monica
  },
  { src: Montana135Bedroom3, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana135, city: Santa_Monica
  },
  { src: Montana135Entry, width: 1.5, height: 1, interiorExterior: 'Exterior', property: Montana135, city: Santa_Monica
  },
  { src: Montana135Desk, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana135, city: Santa_Monica
  },
  { src: Montana135FountainView, width: 1.5, height: 1, interiorExterior: 'Exterior', property: Montana135, city: Santa_Monica
  },
  { src: bathroom, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana135, city: Santa_Monica
  },
  { src: Montana135Kitchen, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana135, city: West_Hollywood
  },
  { src: Montana135LivingRoom, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana135, city: Santa_Monica
  },
  { src: Montana135LivingRoom2, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana135, city: Santa_Monica
  },
  { src: Montana135Path, width: 1.5, height: 1, interiorExterior: 'Exterior', property: Montana135, city: Santa_Monica
  },
  { src: Montana135PropertyCourtyard, width: 1.5, height: 1, interiorExterior: 'Exterior', property: Montana135, city: Santa_Monica
  },
  { src: Montana135UnitBedroom, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana135, city: Santa_Monica
  },
  { src: Montana135UnitHallwayView, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana135, city: Santa_Monica
  },
  { src: Montana135UnitLivingRoom, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana135, city: Santa_Monica
  },
  { src: Montana435DiningRoomExpandedView, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana435, city: Santa_Monica
  },
  { src: Montana435Entry, width: 1.5, height: 1, interiorExterior: 'Exterior', property: Montana435, city: Santa_Monica
  },
  { src: Montana435KitchenGrey, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana435, city: Santa_Monica
  },
  { src: Montana435LivingRoom2, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana435, city: Santa_Monica
  },
  { src: Studio135Montana, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana435, city: Santa_Monica
  },
  { src: ToiletAndSink, width: 1.5, height: 1, interiorExterior: 'Interior', property: Montana135, city: Santa_Monica
  },
  { src: ViewFrom135, width: 1.5, height: 1, interiorExterior: 'Exterior', property: Montana135, city: Santa_Monica
  }
]*/



// WEBPACK FOOTER //
// ./src/Gallery.js